import React__default from 'react';

/**
 * Render the header cell for the week numbers column.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function WeekNumberHeader(props) {
    return React__default.createElement("th", { ...props });
}

export { WeekNumberHeader };
